<mat-toolbar color="primary">
  <div fxHide.gt-xs> 
      <button mat-icon-button (click)="onToggleSideNav()">
          <mat-icon>menu</mat-icon>
      </button></div>
  <div><a routerLink="/">Get Fit With Me</a></div>
  <div fxFlex fxLayout fxLayoutAlign="flex-end" fxHide.xs>
      <ul fxLayout class="navigation-items" fxLayoutGap="10px">
          <li *ngIf="!isAuth"> <a routerLink="/signup">Signup</a></li>
          <li *ngIf="!isAuth"> <a routerLink="/login">Login</a></li>
          <li *ngIf="isAuth"> <a routerLink="/training">Training</a></li>
          <li *ngIf="isAuth"> <a style="cursor: pointer;" (click)="onLogout()">Logout</a></li>
      </ul>
  </div>
</mat-toolbar>